import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import './UserDetails.css';
import MarkdownRenderer from '../../utils/MarkdownRenderer';
import '../../utils/MarkDownRenderer.css';
import axios from 'axios';

const UserDetails = () => {
  const API_BASE_URL = process.env.REACT_APP_SERVER_URL || '';
  const { userId } = useParams(); // <-- grabs ":id" from URL
  console.log("User id", userId)
  const navigate = useNavigate();

  const handleBackToUsers = () => {
    navigate('/settings/admin-panel/user_management'); // Adjust this path to match your routing structure
  };
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [resetPassword, setResetPassword] = useState(null);
  const [isResetting, setIsResetting] = useState(false);
  const [showChats, setShowChats] = useState(false);
  const [userChats, setUserChats] = useState([]);
  const [loadingChats, setLoadingChats] = useState(false);
  const [chatError, setChatError] = useState(null);
  const [selectedChat, setSelectedChat] = useState(null);
  const [showChatMessages, setShowChatMessages] = useState(false);

  console.log(user, 'user-state');//user-state
  console.log("last login", user?.lastActive)
  // Get token safely
  const getToken = useCallback(() => {
    try {
      return typeof Storage !== 'undefined' ? localStorage.getItem('token') : null;
    } catch (error) {
      console.warn('localStorage not available:', error);
      return null;
    }
  }, []);

  // Validate required props
  useEffect(() => {
    if (!userId) {
      setError('User ID is required');
      setLoading(false);
      return;
    }
  }, [userId]);

  // Fetch user details
  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!userId) return;

      const token = getToken();
      if (!token) {
        setError('Authentication token not found');
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      console.log("Fetching user details...", userId);
      try {
        const response = await fetch(`${API_BASE_URL}/api/admin/getuser/${userId}`, {
          method: 'GET',
          credentials: 'include',
          // headers: {
          //   'Content-Type': 'application/json',
          //   'Authorization': `Bearer ${token}`
          // }
        });

        if (!response.ok) {
          if (response.status === 401) {
            throw new Error('Unauthorized access. Please login again.');
          }
          if (response.status === 404) {
            throw new Error('User not found');
          }
          throw new Error(`Failed to fetch user details: ${response.statusText}`);
        }

        const userData = await response.json();
        console.log(userData, 'userdata')
        // Validate response data
        if (!userData || typeof userData !== 'object') {
          throw new Error('Invalid user data received');
        }

        setUser(userData);
      } catch (err) {
        console.error('Error fetching user details:', err);
        setError(err.message);

        // Show user-friendly error notification
        showErrorNotification(`Failed to load user details: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, [userId, API_BASE_URL, getToken]);

  // Simple notification function (replace with your preferred notification system)
  const showErrorNotification = (message) => {
    // You can replace this with toast notifications, custom modals, etc.
    console.error('User notification:', message);
    // Example: toast.error(message);
  };

  const showSuccessNotification = (message) => {
    console.log('Success notification:', message);
    // Example: toast.success(message);
  };

  // Handle Reset Password with better security
  // const handleResetPassword = async () => {
  //   console.log(user, 'user-reset')
  //   if (!user) return;

  //   // Simple confirmation (replace with your modal system)
  //   const confirmed = window.confirm(
  //     `Are you sure you want to reset the password for ${user.name || user.email}?`
  //   );

  //   if (!confirmed) return;

  //   const token = getToken();
  //   if (!token) {
  //     showErrorNotification('Authentication token not found');
  //     return;
  //   }

  //   setIsResetting(true);
  //   setResetPassword(null);

  //   try {
  //     const response = await fetch(`${API_BASE_URL}/api/admin/reset-password`, {
  //       method: 'PUT',
  //       credentials: 'include',
  //       // headers: {
  //       //   'Content-Type': 'application/json',
  //       //   'Authorization': `Bearer ${token}`
  //       // },
  //       body: JSON.stringify({
  //         userId: user.id || user._id,
  //         email: user.email
  //       }),
  //     });

  //     if (!response.ok) {
  //       if (response.status === 401) {
  //         throw new Error('Unauthorized. Please login again.');
  //       }
  //       throw new Error(`Failed to reset password: ${response.statusText}`);
  //     }

  //     const responseData = await response.json();

  //     if (!responseData.newPassword) {
  //       throw new Error('No password received from server');
  //     }

  //     setResetPassword(responseData.newPassword);
  //     showSuccessNotification('Password reset successfully. New password has been sent to user\'s email.');

  //   } catch (resetError) {
  //     console.error('Error resetting password:', resetError);
  //     showErrorNotification(`Failed to reset password: ${resetError.message}`);
  //   } finally {
  //     setIsResetting(false);
  //   }
  // };



const handleResetPassword = async () => {
  console.log(user, 'user-reset');
  if (!user) return;

  const confirmed = window.confirm(
    `Are you sure you want to reset the password for ${user.name || user.email}?`
  );

  if (!confirmed) return;

  const token = getToken();
  if (!token) {
    showErrorNotification('Authentication token not found');
    return;
  }

  setIsResetting(true);
  setResetPassword(null);

  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/admin/reset-password`,
      {
        userId: user.id || user._id,
        email: user.email
      },
      {
        credentials: true, // same as fetch
        // headers: {
        //   'Content-Type': 'application/json',
        //   'Authorization': `Bearer ${token}`
        // },
        // xsrfCookieName: "XSRF-TOKEN",
        // xsrfHeaderName: "x-csrf-token"
      }
    );

    const responseData = response.data;

    if (!responseData.newPassword) {
      throw new Error('No password received from server');
    }

    setResetPassword(responseData.newPassword);

    showSuccessNotification(
      "Password reset successfully. New password has been sent to user's email."
    );

  } catch (resetError) {
    console.error('Error resetting password:', resetError);

    const message =
      resetError.response?.data?.message ||
      resetError.message ||
      'Something went wrong';

    showErrorNotification(`Failed to reset password: ${message}`);
  } finally {
    setIsResetting(false);
  }
};

  // Handle View Chats
  const handleViewChats = async () => {
    if (!user) return;

    const token = getToken();
    if (!token) {
      showErrorNotification('Authentication token not found');
      return;
    }

    setLoadingChats(true);
    setChatError(null);
    setShowChats(true);

    try {
      // Use admin API endpoint for user-specific chats
      const response = await fetch(`${API_BASE_URL}/api/admin/users/${user.id || user._id}/chats`, {
        method: 'GET',
        credentials: 'include',
        // headers: {
        //   'Content-Type': 'application/json',
        //   'Authorization': `Bearer ${token}`
        // }
      });

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error('Unauthorized. Please login again.');
        }
        if (response.status === 404) {
          throw new Error('No chats found for this user');
        }
        throw new Error(`Failed to fetch chats: ${response.statusText}`);
      }

      const chatsData = await response.json();
      console.log('Chats data received:', chatsData);

      // Since we're using admin endpoint, chats are already filtered for the user
      setUserChats(chatsData || []);

    } catch (chatFetchError) {
      console.error('Error fetching chats:', chatFetchError);
      setChatError(chatFetchError.message);
      showErrorNotification(`Failed to fetch chats: ${chatFetchError.message}`);
    } finally {
      setLoadingChats(false);
    }
  };

  // Handle close chats view
  const handleCloseChats = () => {
    setShowChats(false);
    setUserChats([]);
    setChatError(null);
    setSelectedChat(null);
    setShowChatMessages(false);
  };

  // Handle viewing individual chat messages
  const handleViewChatMessages = async (chat) => {
    setSelectedChat(chat);
    setShowChatMessages(true);

    // Fetch detailed messages for this chat using dashboard API
    const token = getToken();
    if (token && chat._id) {
      try {
        const response = await fetch(`${API_BASE_URL}/api/chat/chats/${chat._id}/messages`, {
          method: 'GET',
          credentials: 'include',
          // headers: {
          //   'Authorization': `Bearer ${token}`,
          //   'Content-Type': 'application/json',
          // },
        });

        if (response.ok) {
          const messages = await response.json();
          setSelectedChat(prevChat => ({
            ...prevChat,
            messages: messages
          }));
        } else {
          console.error('Failed to fetch chat messages:', response.status);
        }
      } catch (error) {
        console.error('Error fetching chat messages:', error);
      }
    }
  };

  // Handle back to chat list
  const handleBackToChatList = () => {
    setSelectedChat(null);
    setShowChatMessages(false);
  };

  // Copy password to clipboard
  const copyToClipboard = async (text) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        showSuccessNotification('Password copied to clipboard');
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        showSuccessNotification('Password copied to clipboard');
      }
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
      showErrorNotification('Failed to copy password');
    }
  };

  // Format date safely with time
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      });
    } catch (error) {
      return 'Invalid date';
    }
  };

  // Format website URL
  const formatWebsiteUrl = (website) => {
    if (!website) return null;
    return website.startsWith('http') ? website : `https://${website}`;
  };

  if (loading) {
    return (
      <div className="user-details-container">
        <div className="loader-container">
          <div className="spinner"></div>
          <p>Loading user details...</p>
        </div>
      </div>
    );
  }

  if (error) {
    console.error("Error fetching user details:", error);
    return (
      <div className="user-details-container">
        <div className="error-message">
          <h3>Unable to Load User Details</h3>
          <p>{error}</p>
          <button className="user-back-button" >
            ← Back to Users List
          </button>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="user-details-container">
        <div className="error-message">
          <h3>User Not Found</h3>
          <p>The requested user could not be found.</p>
          <button className="user-back-button" >
            ← Back to Users List
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="user-details-container">
      <div className="user-details-header" onClick={handleBackToUsers}>
        <button className="user-back-button">
          ← Back to Users List
        </button>
        <h2>User Details</h2>
        <div className="header-actions">
          {/* <button 
            className="edit-user-button"
            
            disabled={!user.id}
          >
            ✏️ Edit User
          </button> */}
          {/* <button 
            className="delete-user-button"
            
            disabled={!user.id}
          >
            🗑️ Delete User
          </button> */}
        </div>
      </div>

      <div className="user-details-content">
        <div className="user-info-card">
          <div className="user-avatar">
            <div className="avatar-placeholder">
              {user.name ? user.name.charAt(0).toUpperCase() :
                user.email ? user.email.charAt(0).toUpperCase() : 'U'}
            </div>
          </div>

          <div className="user-info-grid">
            <div className="info-group">
              <label>Full Name</label>
              <p>{user.name || 'N/A'}</p>
            </div>

            <div className="info-group">
              <label>Email Address</label>
              <p>{user.email || 'N/A'}</p>
            </div>

            <div className="info-group">
              <label>Phone Number</label>
              <p>{user.phone || 'N/A'}</p>
            </div>

            <div className="info-group">
              <label>Website</label>
              <p>
                {user.website ? (
                  <a
                    href={formatWebsiteUrl(user.website)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {user.website}
                  </a>
                ) : 'N/A'}
              </p>
            </div>

            <div className="info-group">
              <label>User ID</label>
              <p>#{user.id || user._id}</p>
            </div>

            <div className="info-group">
              <label>Account Status</label>
              <p>
                <span className={`status-badge ${user.status?.toLowerCase() || 'active'}`}>
                  {user.status || 'Active'}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="password-management-card">
          <h3>User Management</h3>
          <div className="password-section">
            <div className="management-buttons">
              <button
                className="reset-password-button"
                onClick={handleResetPassword}
                disabled={isResetting || !(user.id || user._id)}
              >
                {isResetting ? '🔄 Resetting...' : '🔄 Reset Password'}
              </button>

              <button
                className="view-user-chats-button"
                onClick={handleViewChats}
                disabled={loadingChats || !(user.id || user._id)}
              >
                {loadingChats ? '💬 Loading...' : '💬 View Chats'}
              </button>
            </div>

            {resetPassword && (
              <div className="new-password-display">
                <div className="password-alert">
                  <strong>New Password Generated:</strong>
                  <div className="password-value">
                    <code>{resetPassword}</code>
                    <button
                      className="copy-button"
                      onClick={() => copyToClipboard(resetPassword)}
                      title="Copy to clipboard"
                    >
                      📋
                    </button>
                  </div>
                  <small>This password has been sent to the user's email address.</small>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="user-activity-card">
          <h3>Account Information</h3>
          <div className="activity-info">
            <div className="activity-item">
              <span className="activity-label">Created:</span>
              <span className="activity-value">
                {formatDate(user.createdAt)}
              </span>
            </div>
            <div className="activity-item">
              <span className="activity-label">Last Updated:</span>
              <span className="activity-value">
                {formatDate(user.updatedAt)}
              </span>
            </div>
            <div className="activity-item">
              <span className="activity-label">Last Login:</span>
              <span className="activity-value">
                {user?.lastActive ? formatDate(user.lastActive) : 'Never'}
              </span>
            </div>
          </div>
        </div>

        {showChats && (
          <div className="user-chats-card">
            <div className="user-chats-header">
              <h3>User Chats</h3>
              <button className="close-user-chats-button" onClick={handleCloseChats}>
                ✕ Close
              </button>
            </div>

            {loadingChats ? (
              <div className="user-chats-loading">
                <div className="spinner"></div>
                <p>Loading chats...</p>
              </div>
            ) : chatError ? (
              <div className="user-chats-error">
                <p>{chatError}</p>
                <button onClick={handleViewChats} className="retry-button">
                  🔄 Retry
                </button>
              </div>
            ) : userChats.length === 0 ? (
              <div className="no-user-chats">
                <p>No chats found for this user.</p>
              </div>
            ) : !showChatMessages ? (
              <div className="user-chats-list">
                {userChats.map((chat, index) => (
                  <div key={chat._id || chat.id || index} className="chat-item">
                    <div className="chat-header">
                      <span className="chat-title">
                        {chat.title || `Chat ${index + 1}`}
                      </span>
                      <span className="chat-date">
                        {formatDate(chat.createdAt || chat.timestamp)}
                      </span>
                    </div>
                    <div className="chat-preview">
                      {chat.messages && chat.messages.length > 0 ? (
                        <p className="last-message">
                          <strong>Last message:</strong> {
                            chat.messages[chat.messages.length - 1].content?.substring(0, 100) ||
                            chat.messages[chat.messages.length - 1].text?.substring(0, 100) ||
                            'No content'
                          }{(chat.messages[chat.messages.length - 1].content?.length > 100 ||
                            chat.messages[chat.messages.length - 1].text?.length > 100) ? '...' : ''}
                        </p>
                      ) : (
                        <p className="no-messages">No messages in this chat</p>
                      )}
                      <div className="chat-stats">
                        <span className="message-count">
                          📧 {chat.messages ? chat.messages.length : 0} messages
                        </span>
                        {chat.status && (
                          <span className={`chat-status ${chat.status.toLowerCase()}`}>
                            {chat.status}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="user-chat-actions">
                      <button
                        className="view-chat-details-button"
                        onClick={() => handleViewChatMessages(chat)}
                      >
                        👁️ View Chat Messages
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              // Chat Messages View (Dashboard-like interface)
              <div className="chat-messages-view">
                <div className="chat-messages-header">
                  <button className="back-to-view-chats-button" onClick={handleBackToChatList}>
                    ← Back to View Chats
                  </button>
                  <h4>{selectedChat?.title || 'Chat Messages'}</h4>
                  <span className="chat-info">
                    {selectedChat?.messages?.length || 0} messages • {formatDate(selectedChat?.createdAt)}
                  </span>
                </div>

                <div className="chat-messages-container">
                  {selectedChat?.messages && selectedChat.messages.length > 0 ? (
                    selectedChat.messages.map((message, index) => {
                      // Handle both 'sender' and 'role' field names
                      const messageSender = message.sender || message.role;
                      const isUser = messageSender === 'user';
                      const isAssistant = messageSender === 'assistant' || messageSender === 'AI';

                      return (
                        <div
                          key={index}
                          className={`message ${isUser ? 'user-message' : 'assistant-message'}`}
                        >
                          <div className="message-header">
                            <span className="message-role">
                              {isUser
                                ? `👤 ${selectedChat.user?.name || user.name || 'User'}`
                                : '🤖 Medhas'}
                            </span>
                            <span className="message-time">
                              {message.timestamp ? formatDate(message.timestamp) : ''}
                            </span>
                          </div>
                          <div className="user-message-content">
                            {isUser ? (
                              message.content || message.text || 'No content'
                            ) : (
                              <>
                                {console.log('UserDetails: Rendering markdown for assistant message:', message.content || message.text)}
                                <MarkdownRenderer text={message.content || message.text || 'No content'} />
                              </>
                            )}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="no-messages-in-chat">
                      <p>No messages in this chat.</p>
                    </div>
                  )}
                </div>

                <div className="chat-readonly-notice">
                  <p>📖 This is a read-only view of the user's chat history.</p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

// Add PropTypes for better development experience
UserDetails.propTypes = {
  userId: (props, propName, componentName) => {
    if (!props[propName]) {
      return new Error(`${propName} is required in ${componentName}`);
    }
  },
  onBack: (props, propName, componentName) => {
    if (typeof props[propName] !== 'function') {
      return new Error(`${propName} must be a function in ${componentName}`);
    }
  },
  onEdit: (props, propName, componentName) => {
    if (typeof props[propName] !== 'function') {
      return new Error(`${propName} must be a function in ${componentName}`);
    }
  },
  onDelete: (props, propName, componentName) => {
    if (typeof props[propName] !== 'function') {
      return new Error(`${propName} must be a function in ${componentName}`);
    }
  }
};

export default UserDetails;